import { useTranslation } from 'react-i18next';
import { useSession } from '../../state/session.tsx';
import { EmptyState } from '../../components/ui.tsx';
import VoiceSettingsCard from '../../components/settings/voice-settings-card.tsx';
import VoiceRoutingCard from '../../components/settings/voice-routing-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/**
 * Settings › Texting & calls › Calls: what a client's call to the company's
 * number does, and the numbers, teams and locations it rings. Nothing from the
 * texting setup mounts here, so opening it reads no Twilio number or
 * registration state.
 */
export default function CallsSettingsPage() {
  const { t } = useTranslation();
  const { company, can } = useSession();
  return (
    <SettingsLeafPage
      title={t('settings.messagingPages.tiles.calls.title')}
      back={{ to: '/settings/messaging', label: t('settings.messagingPages.backToMessaging') }}
    >
      {!can('company:write') ? (
        <EmptyState title={t('settings.messagingPages.noAccess')} />
      ) : !company?.voiceInboxAvailable ? (
        <EmptyState title={t('settings.messagingPages.callsUnavailable')} />
      ) : (
        <>
          <VoiceSettingsCard />
          <VoiceRoutingCard />
        </>
      )}
    </SettingsLeafPage>
  );
}
